import styles from "../style";
import data from "../constants/data";
import { Reveal } from "./reveal";

const Thesis = () => {
  return (
    <div className="py-40 w-full px-4 flex flex-col items-center justify-center">
      <div className="flex flex-col gap-6 max-w-[1200px]">
        {data.map((card, index) => (
          <div key={index} className="relative w-full">
            {/* Number as background element */}
            <span className="absolute left-6 md:top-10 top-3 md:-translate-y-1/2 text-[60px] font-bold text-secondary select-none pointer-events-none z-0 leading-none">
              {card.number}
            </span>
            
            {/* Content container with proper spacing for text visibility */}
            <div className="relative z-10 ml-16 pb-4 border-b border-1 border-second max-w-[600px]">
              <div className="flex flex-row gap-2 items-center w-full justify-between">
                <Reveal>
                  <h2 className="xs:text-mm text-sm font-semibold break-words hyphens-auto max-w-[240px]">
                    {card.name}
                  </h2>
                </Reveal>               
                
                <Reveal>
                  <p className="xs:text-sm text-ss break-words hyphens-auto leading-relaxed text-secondary max-w-[340px] pr-10 pb-4">
                    {card.detail}
                  </p>
                </Reveal>
              </div>
            </div>                
          </div>
        ))}      
      </div>
    </div> 
  );
};

export default Thesis;